/**
 *  interacts with the page
 */

export default {
    trackingId: null,
    gtag() {
        window.dataLayer.push(arguments);
    },
    load(countryCode) {
        window.dataLayer = window.dataLayer || [];
        this.trackingId = (countryCode === 'IN' ? 'G-VDQ8E48EVM' : 'G-XPB1JK7D9X')
        this.lazy('https://www.googletagmanager.com/gtag/js?id=' + this.trackingId).then(() => {
            this.gtag('js', new Date());
            this.gtag('config', this.trackingId, {
                anonymize_ip: true,
            });
        });
    },
    lazy(path) {
        return new Promise(resolve => {
            const script = window.document.createElement('script');
            script.src = path;
            script.async = true;
            script.onload = () => resolve();
            window.document.head.appendChild(script);
        });
    }
};



